import React, { useState, useEffect } from "react";
import { Logo } from "../components/Logos/Logo";
import MainImage from "./MainImage";
import NewsText from "./NewsText";
import Popup from "../components/smiWidgets/Popup";
import SmiJs from "../components/SmiJs";
import BlurReload from "../utils/blurReload";
import BackClick from "../components/smiWidgets/BackClick";
import { widgetIds } from "./smiWidgets/widgetIds";
import { AdfoxInvisible } from "../components/adfoxBlocks/InvisibleAdfox";
import { AdSlot } from "../components/ads/AdSlot";
import { isDbMode, resolveJsonObjectId, resolveRefresh, resolveSlotValue } from "../utils/adConfig";
import { getCookie, deleteCookie } from "./cookieManager";
import { hideElements } from "./elementVisibility";
import { fetchJsonAds } from "../services/fetchJsonAds";
import { useBillingNotice } from "../services/billingNotice";
import { fetchJsonAdsCount } from "../constants";
import { AdfoxHeaderBidding } from "../components/AdfoxHeaderBidding";
import { hbConfig } from "./HeaderBidding/HBConfig";
import { adfoxOptions } from "./adfox/adfoxOptions";
import { YandexAd } from "../components/YandexAd/YandexAd";
import { YandexFullScreen } from "../components/YandexAd/FullScreen";
import { AdfoxBlock } from "../components/adfoxBlocks/AdfoxBlock";
import { ToPad } from "../components/jsonBlocks/ToPad/ToPad";
import { Feed } from "../components/jsonBlocks/Feed/Feed";
import MoeVideo from "../components/smiWidgets/MoeVideo";
import AnalyticsTracker from "../components/AnalyticsTracker";

export default function Template48306Component({
    news,
    context,
    isFull,
    isDesktop,
    showBackClick,
    showPopUp,
    popUpType,
    refreshTime = 10,
    showMainLogo,
    fprVersion,
    currentDomain,
    userId,
    showId,
}) {
    const [billingNoticeUrl, setBillingNoticeUrl] = useState(null);
    const [jsonData, setJsonData] = useState([]);
    const showJson = ["2", "3", "4", "66972"].includes(fprVersion);
    const showJsonIr = ["main", "48306", "2", "3"].includes(fprVersion);
    const showFeed = ["2", "3", "5"].includes(fprVersion);
    const hideBlock = ["main", "48306"].includes(fprVersion);
    const hideToPad = ["66972"].includes(fprVersion);
    // Подстраховка «как в main» — та же, что уже стоит в остальных шаблонах. Сегодня
    // она не срабатывает: Core сам приводит версию к `main`, и undefined сюда не
    // доходит. Нужна на случай версии, которой нет в карте: без неё обращение к
    // adfoxBlocks уронило бы весь компонент, а не один блок.
    const adfoxBlocks = adfoxOptions[fprVersion] || adfoxOptions["main"];
    const showAdfox = true;
    // Кампания в БД: реклама только оттуда. Списки версий выше решают лишь
    // фолбэки AdSlot, которые в этом режиме не рендерятся, а блоки мимо AdSlot
    // ниже выключаются этим флагом.
    const dbMode = isDbMode();

    const widgetBlocks = widgetIds[fprVersion] || widgetIds["main"];
    const bundleObjectId = isFull
        ? isDesktop
            ? widgetBlocks.json.fullPc
            : widgetBlocks.json.fullMob
        : isDesktop
        ? widgetBlocks.json.prevPc
        : widgetBlocks.json.prevMob;
    const objectId = resolveJsonObjectId({ isFull, isDesktop, fallback: bundleObjectId });

    const yandexFeedOptions = !dbMode && adfoxBlocks.feed ? adfoxBlocks.feed[isFull ? "fullMob" : "prevMob"] : [];
    const yandexFeedId = yandexFeedOptions.length > 0 ? yandexFeedOptions[0].blockId : null;
    const yandexFeedType = yandexFeedOptions.length > 0 ? yandexFeedOptions[0].type : null;

    // Одно значение на оба пропа: MoeVideo подставляет его и при пустом ответе, и при ошибке.
    const yaFloorAdId = resolveSlotValue("yafloorad", { isFull, isDesktop, fallback: widgetBlocks.yaFloorAd });

    const popupIds = resolveSlotValue("popup", { isFull, isDesktop, fallback: widgetBlocks.popup });
    const backClickIds = resolveSlotValue("backclick", { isFull, isDesktop, fallback: widgetBlocks.backClick });
    const {
        page: refreshPage,
        useRss: refreshRss,
        rssUrl: refreshRssUrl,
        delay: refreshDelay,
    } = resolveRefresh({
        isFull,
        isDesktop,
        fallback: widgetBlocks.refresh,
    });

    const [isReloaded, setIsReloaded] = useState(() => getCookie("wasReloaded") === "true");

    useBillingNotice(billingNoticeUrl);

    const url = new URL(window.location.href);
    const fullNewsUrl = new URL(url);
    if (fullNewsUrl.pathname.includes("preview/")) {
        fullNewsUrl.pathname = fullNewsUrl.pathname.replace(/\/(preview|news|preview\/news)\//, "full/");
    } else {
        fullNewsUrl.searchParams.set("view", "full");
    }

    let sid = context.analytics_lable;

    useEffect(() => {
        if (isReloaded) {
            hideElements();
        }
    }, [isReloaded]);

    useEffect(() => {
        const handleBeforeUnload = () => {
            if (!getCookie("isProgrammaticReload")) {
                deleteCookie("wasReloaded");
            }
            deleteCookie("isProgrammaticReload");
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        if (!userId || !showId) return;
        // Ленты в БД нет — тизерам взяться неоткуда, бандловую не подставляем.
        if (dbMode && !objectId) return;

        const fetchData = async () => {
            try {
                const data = await fetchJsonAds(objectId, fetchJsonAdsCount, userId, showId, context.utm_term);
                setJsonData(data.news || []);
                setBillingNoticeUrl(data.billingNoticeUrl);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [userId, showId, objectId]);

    const handleArticleReload = () => {
        document.cookie = "wasReloaded=true; path=/";
        document.cookie = "isProgrammaticReload=true; path=/";
        setTimeout(() => {
            window.location.reload();
        }, 100);
    };

    return (
        <div id="wrapper">
            {showAdfox && <AdfoxHeaderBidding hbConfig={hbConfig} templateVersion={fprVersion} />}
            {showPopUp && (!dbMode || popupIds) && (
                <Popup popUpType={popUpType} adIds={popupIds} domain={currentDomain} isDesktop={isDesktop} />
            )}
            {showBackClick && (!dbMode || backClickIds) && (
                <BackClick maxRedirectsCount={1} block_id={backClickIds} domain={currentDomain} />
            )}
            {(!dbMode || refreshPage || refreshRss) && (
                <BlurReload
                    isDesktop={isDesktop}
                    domain={currentDomain}
                    refresh={refreshPage}
                    useRss={refreshRss}
                    rssUrl={refreshRssUrl}
                    delay={refreshDelay}
                    sid={sid}
                    timeout={refreshTime}
                />
            )}
            <AdSlot
                slot="fullscreen"
                isFull={isFull}
                isDesktop={isDesktop}
                json={null}
                fallback={<YandexFullScreen isDesktop={isDesktop} isFull={isFull} options={adfoxBlocks.fullScreen} />}
            />
            <SmiJs context={context} />
            <img src="https://data.24smi.net/ctp?id=1" width="1" height="1" />
            <div className="wrapper-holder">
                <header id="header" className="flex">
                    <strong className="logo">
                        <a href="#">
                            <Logo isDark={true} showMainLogo={showMainLogo} />
                        </a>
                    </strong>
                </header>
                <main id="main">
                    {/* В режиме БД topad один: какой из двух и есть ли он вовсе — решали списки версий. */}
                    {dbMode && (
                        <AdSlot
                            slot="topad"
                            isFull={isFull}
                            isDesktop={isDesktop}
                            json={<ToPad jsonData={jsonData.slice(0, 2)} objectId={objectId} showId={showId} />}
                        />
                    )}
                    {!dbMode && !showJson && !hideBlock && (
                        <AdSlot
                            slot="topad"
                            isFull={isFull}
                            isDesktop={isDesktop}
                            fallback={<AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adfoxBlocks.toPad} />}
                        />
                    )}
                    {!dbMode && showJson && !hideBlock && !hideToPad && (
                        <AdSlot
                            slot="topad"
                            isFull={isFull}
                            isDesktop={isDesktop}
                            fallback={<ToPad jsonData={jsonData.slice(0, 2)} objectId={objectId} showId={showId} />}
                        />
                    )}
                    <div className="main-holder">
                        <section id="content">
                            <div className="post-picture">
                                <div className="news-title-200">
                                    {isReloaded ? (
                                        <a href={fullNewsUrl.toString()} target="_blank">
                                            {news.title}
                                        </a>
                                    ) : (
                                        news.title
                                    )}
                                </div>
                                <MainImage news={news} fullNewsUrl={fullNewsUrl} isReloaded={isReloaded} />
                            </div>
                            <NewsText
                                news={news}
                                jsonData={jsonData.slice(8, 24)}
                                isFull={isFull}
                                isDesktop={isDesktop}
                                objectId={objectId}
                                onReload={handleArticleReload}
                                showId={showId}
                                fullNewsUrl={fullNewsUrl}
                                showAdfox={showAdfox}
                                options={adfoxBlocks}
                                fprVersion={fprVersion}
                                showJson={showJson}
                                showJsonIr={showJsonIr}
                                dbMode={dbMode}
                            />
                            {yandexFeedId && yandexFeedType && (
                                <YandexAd blockId={yandexFeedId} type={yandexFeedType} />
                            )}
                            {/* Лента без слота: в режиме БД — только если лента заведена в БД. */}
                            {(dbMode ? Boolean(objectId) : showFeed) && (
                                <Feed
                                    initialData={jsonData.slice(36, 48)}
                                    object={objectId}
                                    showId={showId}
                                    isDesktop={isDesktop}
                                    userId={userId}
                                    utmTerm={context.utm_term}
                                />
                            )}
                            <AdfoxInvisible isTop={true} />
                            <AdfoxInvisible isTop={false} />
                        </section>
                    </div>
                    <footer className="down" />
                </main>
            </div>
            <AnalyticsTracker
                newsId={news.id}
                streamId={context.stream_id}
                isFull={isFull}
                sessionId={context.session_id}
                visitorId={context.visitor_id}
                utmParams={context.utm_params}
                device={context.device}
                browser={context.browser}
            />
            {/* floorad в режиме БД — место RTB в аукционе против «Моё видео»: без него победа RTB пустая. */}
            {dbMode && <AdSlot slot="floorad" isFull={isFull} isDesktop={isDesktop} json={null} />}
            <AdSlot
                slot="moevideo"
                isFull={isFull}
                isDesktop={isDesktop}
                render={(entry) => (
                    <MoeVideo
                        placements={entry.blockId}
                        isFull={isFull}
                        isDesktop={isDesktop}
                        closeSecOffset={4}
                        yaFloorAdOnEmpty={yaFloorAdId}
                        yaFloorAdOnError={yaFloorAdId}
                    />
                )}
                json={null}
                fallback={
                    <MoeVideo
                        placements={widgetBlocks.moeVideo}
                        isFull={isFull}
                        isDesktop={isDesktop}
                        closeSecOffset={4}
                        yaFloorAdOnEmpty={yaFloorAdId}
                        yaFloorAdOnError={yaFloorAdId}
                    />
                }
            />
        </div>
    );
}
